import { render } from "./GroupingRouteContainer.vue?vue&type=template&id=9e22e840&scoped=true"
import script from "./GroupingRouteContainer.vue?vue&type=script&lang=js"
export * from "./GroupingRouteContainer.vue?vue&type=script&lang=js"

import "./GroupingRouteContainer.vue?vue&type=style&index=0&id=9e22e840&scoped=true&lang=css"

import exportComponent from "/home/salih/development/sayberdata-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e22e840"]])

export default __exports__